import { Button, ButtonStyles, Popup } from '@silverfort/sf-components';
import React, { useState } from 'react';
import { JitPolicyModel } from '../types/JitTypes';
import { FencingPolicyForServer } from '../types/FencingTypes';
import { BulkAction, BulkPolicyCreationResponse } from '../types/PrivilegedAccountsTypes';

export interface CreateBulkPolicyProps {
    open: boolean;
    onClose: () => void;
    onSave: (message: string) => void;
    onError: (error: string) => void;
    bulkAction: BulkAction | null;
    accountGuids: string[];
    shouldVerifyAction: boolean;
}

interface VerificationPopupProps {
    action: BulkAction;
    accountGuidsCount: number;
    onApprove: () => void;
    onCancel: () => void;
}

export const VerificationPopup = ({ action, accountGuidsCount, onApprove, onCancel }: VerificationPopupProps) => {
    return (
        <Popup
            className="z-[7000]"
            popupClassName="w-[360px] h-[200px]"
            open={true}
            title={'Bulk ' + (action === BulkAction.JIT ? 'JIT' : 'Virtual Fencing') + ' Policy'}
            ContentComponent={() => (
                <div>
                    Applying this policy in bulk will override existing PAS policies for {accountGuidsCount} accounts.
                </div>
            )}
            onClose={onCancel}
            onApprove={onApprove}
            FooterComponent={() => (
                <div className="flex flex-1 justify-end gap-2 ">
                    <Button buttonStyle={ButtonStyles.GhostSolid} text="Cancel" onClick={onCancel} />
                    <Button buttonStyle={ButtonStyles.PrimarySolid} text="Save" onClick={onApprove} />
                </div>
            )}
        />
    );
};

export const handlePolicyCreationResponse = (
    response: BulkPolicyCreationResponse,
    policyType: 'JIT' | 'Virtual Fencing',
    accountGuidsCount: number,
    onError: (error: string) => void,
    onSave: (message: string) => void
) => {
    if (response.status === 206) {
        onError(
            `${accountGuidsCount} operations failed due to errors.\n${policyType} policy updated to ${
                response?.data?.updatesCount || 0
            } accounts.`
        );
        return;
    }
    if (response.status !== 200) {
        onError(`${accountGuidsCount} operations failed due to errors.`);
        return;
    }
    onSave(`Bulk ${policyType} policy updated to ${accountGuidsCount} accounts`);
};
